import React, { useState, useEffect } from "react";
import { TYPE_SUCCESS, TYPE_FAIL, INTERVAL } from "assets/constants/Constants";
import { ThemeProvider } from '@mui/styles';
import MaterialTable from "material-table";
import { createTheme } from '@mui/material';
import {ACCOUNT_ICON,CALENDER_ICON ,EDIT_ICON, TRASH_ICON,} from "assets/constants/Icons";
import "./user-style.css";
import moment from 'moment';
import { hasPermission } from 'components/Permission';
import { getSubscriptionList,deleteSubscriptionCall } from "lib/axiosUtils";
import { useHistory } from "react-router-dom";
import ShowToast from 'components/ShowToast';
import Spinner from 'components/Spinner';
import { SUPER_ADMIN,READONLY } from 'assets/constants/Constants';

const SubscriptionMaster = () => {
    const history = useHistory();
    const [subscriptions, setSubscriptions] = useState([]);
    const [tableActionsArray, setTableActionsArray] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const userRole = JSON.parse(localStorage.getItem("userRole"));

    useEffect(() => {
        fetchSubscritionData();
    }, []);

    useEffect(() => {
    const fetchSubscriptionList = async () => {
        try {
            const data = await getSubscriptionList({}, {});
            console.log(data);

            setSubscriptions(data.data.result);
        }
        catch (error) {
            console.log("error while fetching data", error);
        }
    }
        fetchSubscriptionList();
    },[]);

    useEffect(() => {
      const tableActions = () => {
        let tableActions = [];
        if (userRole.user_role === SUPER_ADMIN) {
          if (hasPermission("subscription", "update")) {
            tableActions.push({
              icon: () => <i className={`${EDIT_ICON}`} title="Edit Subscription"></i>,
              onClick: (event, rowData) => editSubscription(rowData)
            })
          }
          if (hasPermission("subscription", "delete")) {
            tableActions.push({
              icon: () => <i className={`${TRASH_ICON}`} title="Delete Subscription"></i>,
              onClick: (event, rowData) => handleDelete(rowData.subscriptionId)
            });
          }
        }
        else if (userRole.user_role === READONLY) {
          // Show only Buy Now button
          tableActions.push({
            icon: () => (
              <button className="brand-button ml-5">
                Buy
              </button>
            ),
            tooltip: "Buy Subscription",
            onClick: (event, rowData) => handleBuyNow(rowData)
          });
        }
        setTableActionsArray(tableActions);
      }
      tableActions();
        // eslint-disable-next-line
    }, [])

    const fetchSubscritionData = async () => {
      try {
          let response = null;
          response = await getSubscriptionList({}, {});
          const data = response.data.result;
          setSubscriptions(data);
          setIsLoading(false);
      } catch (error) {
          setIsLoading(false);
          console.log("Error while fetching Program Data", error);
      }
    }

    const createSubscription = () => {
     window.location.href = "/create-subscription-page";
    }

    const editSubscription = (data) => {
        history.push("/create-subscription-page", data);
    }

    const handleDelete = async (item) => {
    if (window.confirm("Are you sure you want to delete this Subscription?")) {
      setIsLoading(true);
      try {
        await deleteSubscriptionCall({}, {}, item);
        ShowToast('Subscription deleted successfully', TYPE_SUCCESS, INTERVAL, "", "");
        await fetchSubscritionData();
        setIsLoading(false);
      } catch (error) {
        setIsLoading(false);
        ShowToast('Something went wrong. Please delete again after some time!', TYPE_FAIL, INTERVAL, "", "");
      }
    }
  }

  const handleBuyNow = (data) => {
    history.push({
        pathname: '/payment/pay',
        state: { 
          redirectedFrom: 'BuySubscription',
          data: data   // 👈 pass the amount here
        }
    });
  }

  const mytheme= createTheme({});
  return (<>
    {
      isLoading === true ? (
        <Spinner />
        ) : 
       (
        <div className="main-content">
          <div className="pagetitle row" style={{ color: 'black', paddingTop: 15 }}>
            <div className="col-md-10 sm_device"><i className={`${ACCOUNT_ICON}`}></i> Subscription</div>
            <div className="col-md-2 sm_device" style={{ textAlign: 'right' }}><i className={`${CALENDER_ICON}`}></i> {moment().format("DD MMM YYYY")}</div>
          </div>
          <div style={{ borderBottom: '1px solid lightgray', marginBottom: 15, marginTop: 15 }} />
          <div className="list-wrapper">
          {
            (hasPermission("subscription", "create") && userRole.user_role === SUPER_ADMIN) && (
              <div className="form-button-div">
                <button className="brand-button" onClick={createSubscription}>Create</button>
              </div>
            )
          }
            <div className="mt-4 border list-table-div site-table" style={{ marginBottom: 50 }}>
                {
                    true ? (
                        <ThemeProvider theme={mytheme}>
                            <MaterialTable
                                columns={[
                                    {
                                        title: "Subscription Name", field: "subscriptionname",
                                        cellStyle: { cellWidth: '12%', color: '#808080', fontSize: 14, textTransform: 'none' }
                                    },
                                    {
                                        title: "Price", field: "price",
                                        cellStyle: { cellWidth: '18%', fontWeight: 'bolder', color: '#000000', fontSize: 14 }
                                    },
                                    {
                                        title: "Credits", field: "credits",
                                        cellStyle: { cellWidth: '18%', fontWeight: 'bolder', color: '#000000', fontSize: 14 }
                                    },
                                    {
                                        title: "Duration", field: "duration",
                                        cellStyle: { cellWidth: '20%', color: '#808080', fontSize: 14, textTransform: 'none' },
                                        sorting: false
                                    }
                                ].filter(Boolean)}
                                data={
                                    subscriptions.map((item) => {
                                      return (
                                        {
                                          subscriptionId: item._id,
                                          subscriptionname: item.subscription_name,
                                          price: item.subscription_price,
                                          credits: item.credits,
                                          duration: item.duration_days                                        
                                        }
                                      )
                                    })
                                }
                                actions={tableActionsArray}
                                options={{
                                    actionsColumnIndex: -1,
                                    headerStyle: {
                                        color: '#999998',
                                        fontWeight: 'bolder',
                                        fontSize: 15
                                    },
                                    filtering: true,
                                    sorting: true,
                                    columnsButton: true,
                                    exportButton: true,
                                    exportFileName: "History Page Data"
                                }}
                            />
                        </ThemeProvider>
                    ) : (
                        <div className="text-center pt-2">
                            <label>Not Found</label>
                        </div>
                    )
                }
            </div>
          </div>
        </div>
      )
    }
  </>);
};

export default SubscriptionMaster;
